export const accountConstants = {
  ACCOUNT_SELECTED: "ACCOUNT_SELECTED",
};
